import { useEffect, useState } from "react";

interface ShareModalProps {
  open: boolean;
  title: string;
  onClose: () => void;
}

const channels = [
  { label: "微信", icon: "ri-wechat-line" },
  { label: "微博", icon: "ri-weibo-line" },
  { label: "豆瓣", icon: "ri-book-2-line" },
  { label: "朋友圈", icon: "ri-share-circle-line" },
];

export default function ShareModal({ open, title, onClose }: ShareModalProps) {
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!open) return;
    setMessage("");
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setMessage("链接已复制（演示提示：未真实分享到外部平台）");
    } catch {
      setMessage("演示模式：此处会复制当前页面的分享链接");
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center px-4">
      <button
        type="button"
        aria-label="关闭分享窗口"
        onClick={onClose}
        className="absolute inset-0 cursor-pointer bg-foreground-950/50"
      />
      <div className="relative w-full max-w-md rounded-lg border border-background-200 bg-background-50 p-6">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="font-heading text-lg font-bold text-foreground-950">分享这部作品</h2>
            <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{title}</p>
          </div>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-600 transition-colors hover:text-primary-600"
          >
            <i className="ri-close-line" />
          </button>
        </div>

        <div className="mt-5 grid grid-cols-4 gap-2">
          {channels.map((channel) => (
            <button
              key={channel.label}
              type="button"
              onClick={() => setMessage(`演示提示：已模拟分享到${channel.label}，未真实发布内容`)}
              className="flex cursor-pointer flex-col items-center gap-2 rounded-md border border-background-200 px-2 py-3 text-[11px] text-foreground-600 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
            >
              <i className={`${channel.icon} text-xl`} />
              {channel.label}
            </button>
          ))}
        </div>

        <button
          type="button"
          onClick={copyLink}
          className="mt-3 flex w-full cursor-pointer items-center justify-center gap-2 rounded-md border border-background-200 px-3 py-2.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-link" />
          复制页面链接
        </button>

        {message && (
          <p className="mt-4 rounded-md bg-accent-50 px-3 py-2.5 text-[11px] leading-relaxed text-accent-800">
            {message}
          </p>
        )}
        <p className="mt-3 text-[11px] leading-relaxed text-foreground-400">
          分享功能为前端演示，不会向任何第三方平台发送内容。
        </p>
      </div>
    </div>
  );
}